<template>
  <div v-if="show" class="video-modal-overlay" @click.self="closeModal">
    <div class="video-modal-card">
      <button class="modal-close-btn" @click="closeModal" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#1D2941"/>
          <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div class="video-modal-header">
        <h2 class="video-modal-title">See MakePing <span class="text-gradient">in action</span></h2>
        <p class="video-modal-subtitle">Watch how easy it is to monitor your websites and get instant alerts.</p>
      </div>

      <div class="video-frame">
        <iframe
          :src="`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`"
          class="video-iframe"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoModal',
  props: {
    show: { type: Boolean, default: false },
    videoId: { type: String, default: 'RI9smuZMtJw' },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400;0,500;0,600;1,500&family=Mulish:wght@600;700&display=swap');

.video-modal-overlay {
  position: fixed;
  z-index: 2000;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(30, 34, 54, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.video-modal-card {
  background: #FFF;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 25px;
  position: relative;
  background-color: #FFFFFF;
  background-image:
    radial-gradient(circle at 10% 10%, #FFE9DE 0%, transparent 40%),
    radial-gradient(circle at 50% 100%, #FFE9DE 0%, transparent 40%);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  z-index: 1;
}

.modal-close-btn:hover {
  opacity: 0.8;
}

.video-modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 20px;
  padding: 0 40px;
}

.video-modal-title {
  color: var(--Dark-blue, #1D2941);
  font-family: 'Mulish', sans-serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 42px;
  letter-spacing: -1px;
  margin: 0 0 8px 0;
}

.text-gradient {
  background: linear-gradient(95deg, var(--Accent---Orange, #F84109) 64.99%, var(--White, #F2F5F7) 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.video-modal-subtitle {
  color: var(--Text, rgba(0, 0, 0, 0.80));
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  margin: 0;
}

.video-frame {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 aspect ratio */
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(29, 41, 65, 0.10);
  background: #1D2941;
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

@media (max-width: 768px) {
  .video-modal-card {
    padding: 20px 15px;
  }
  .video-modal-header {
    padding: 0 30px;
    margin-bottom: 15px;
  }
  .video-modal-title {
    font-size: 24px;
    line-height: 32px;
  }
  .video-modal-subtitle {
    font-size: 13px;
  }
}
</style>
